import React from "react";
import { Box } from "@mui/material";
import LandslideOutlinedIcon from "@mui/icons-material/LandslideOutlined";

const OrgUnitLegend = () => (
  <Box>
    <b>OrgUnit</b>
    <Box pl={3}>
      <LandslideOutlinedIcon />
    </Box>
  </Box>
);

export default OrgUnitLegend;
